/// <reference path="Main.js" />
/// <reference path="Enumeration-vsdoc.js" />
/// <reference path="Strings-vsdoc.js" />
/// <reference path="fetcher.js"/>

/* global fetcher */
/* exported SetId */

window.JJK = window.JJK || {};

// Begin JJK.AboAuftraegeListe *************************************************************************************************
JJK.AboAuftraegeListe = function (options) {
	$.extend(this, options);
	const self = this;
	$(() => {
		self.Init();
	});
};

JJK.AboAuftraegeListe.prototype = {
	AboTemplateId: null,
	SonderpostenArtikelId: null,
	VonId: null,
	VonFormatiertId: null,
	BisFormatiertId: null,
	FormId: null,
	ZuzahlungId: null,
	WertAboTemplate: '',
	WertSonderpostenArtikel: '',
	TemplateGewaehltAjaxUrl: null,
	StartdatumGeaendertAjaxUrl: null,
	AboAuftragId: null,
	RefreshId: null,
	KeineZuzahlung: null,
	ChildAboGewaehltAjaxUrl: null,
	ermittleStartundLetztesVersandDatumUrl: null,
	aktuelleSprache: null,
	ermittleStartundLetztesVersandDatumFuerKombiUrl: null,

	Init: function () {
		this.WertAboTemplate = $(`#${this.AboTemplateId}`).val();
		this.WertSonderpostenArtikel = $(`#${this.SonderpostenArtikelId}`).val();
		this.allePraemien = this.allePraemienJson ? JSON.parse(this.allePraemienJson) : [];
		this.istNeuesAboShopDesign = jjk.design.Name === 'TopMenue' || jjk.design.Name === 'VerlagsportaliFrame';
		this.ErzeugeEvents();
		this.ermittleStartundLetzteVersandDatum();
	},
	ErzeugeEvents: function () {
		const self = this;
		const form = $(`#${this.AboTemplateId}`).closest('form');
		self.SetzeKombiAusgaben(form);
		if (this.SonderpostenArtikelId) {
			$(`[id^="${this.SonderpostenArtikelId}"]`)
				.on('change', function () {
					const templateId = $(this).closest('form').data('aboTemplateId');
					const gewaehltePraemieId = parseInt($(this).val(), 10);
					/** @type {{Id: number, ZuzahlungText: string, Zuzahlung:number }} */
					const gewaehltePraemieDaten = self.allePraemien.find(p => p.Id === gewaehltePraemieId);
					if (gewaehltePraemieDaten) {
						if (gewaehltePraemieDaten.Zuzahlung > 0) {
							$(`#${self.ZuzahlungId}${templateId}`).html(gewaehltePraemieDaten.ZuzahlungText);
							$(`#zuzahlungsText${templateId}`).show();
							$(`#btnPayPalDirekt_${templateId}`).hide();
							$(this).closest('form').find('#IstPayPalWorkflow').val(false);
						} else {
							$(`#btnPayPalDirekt_${templateId}`).show();
							$(`#zuzahlungsText${templateId}`).hide();
						}
					} else {
						$(`#zuzahlungsText${templateId}`).hide();
						$(`#btnPayPalDirekt_${templateId}`).hide();
					}
				})
				.trigger('change');
		}

		$('.sp-artikel-card').on('click', function () {
			const sonderpostenId = $(this).data('sonderpostenId');
			const templateId = $(this).data('templateId');
			$(this).closest('.sp-artikel-row').find('.sp-artikel-card').removeClass('selected');
			$(this).addClass('selected');
			$(`#GewaehltePraemie${templateId}`).val(sonderpostenId).trigger('change');
		});
		$('.praemien-modal-dialog')
			.find('.sp-artikel-card')
			.on('click', function () {
				$(this).closest('.modal').modal('hide');
			});

		const datumId = self.istNeuesAboShopDesign ? self.AngezeigtesDatumId : self.VonId;
		$(`input[id^="${datumId}"]`).each(function () {
			const templateId = this.id.replace(datumId, '');
			$(this).on('change', async function () {
				const von = $(this).val();
				const gewaehlteAbos = $(this)
					.closest('form')
					.find('select[name^="GewaehlteAbos"]')
					.map((idx, elem) => $(elem).val())
					.toArray()
					.filter(x => x > 0);
				await fetcher.post(self.TemplateGewaehltAjaxUrl, $(`#${self.FormId}${templateId}`).serialize(), 'application/x-www-form-urlencoded; charset=UTF-8');
				const result = await fetcher.postJson(self.StartdatumGeaendertAjaxUrl, { startdatum: von, gewaehlteAbos: gewaehlteAbos });
				if (self.istNeuesAboShopDesign) {
					$(`#${self.VonEingegebenId}${templateId}`).val(von);
					$(`#${self.AngezeigtesDatumId}${templateId}`).val(result.ErsterLiefertermin);
				} else {
					$(`#${self.VonFormatiertId}${templateId}`).html(result.ErsterLieferterminMitText);
					$(`#${self.BisFormatiertId}${templateId}`).html(result.LetzterLieferterminMitText);
				}
			});
		});

		// Kombi-Abos
		$('[name^="GewaehlteAbos"]')
			.on('change', async function () {
				const $select = $(this);
				const form = $select.closest('form');
				const childAboTemplateId = parseInt($select.val(), 10);
				const liefertageText = await fetcher.postJson(self.ChildAboGewaehltAjaxUrl, { childAboTemplateId });
				const gewaehlteChildAbos = form
					.find('select[name^="GewaehlteAbos"]')
					.map((idx, elem) => $(elem).val())
					.toArray();
				const wurdenAlleChildAbosGewaehlt = gewaehlteChildAbos.every(x => x > 0);
				const datumId = self.istNeuesAboShopDesign ? self.AngezeigtesDatumId : self.VonId;
				const templateId = form.attr('data-abo-template-id');
				const vonEingegeben = $(`#VonEingegeben${templateId}`).val();
				if (wurdenAlleChildAbosGewaehlt) {
					$(`#${datumId}${templateId}`).datepicker('setDate', null).datepicker('destroy');
					const result = await fetcher.postJson(self.ermittleStartundLetztesVersandDatumFuerKombiUrl, {
						GewaehltesAboTemplateId: templateId,
						GewaehlteAbos: gewaehlteChildAbos,
						VonEingegeben: vonEingegeben,
					});
					$(`#${self.VonEingegebenId}${templateId}`).val(result.VonEingegeben);
					$(`#${datumId}${templateId}`).val(result.AngezeigtesDatum).attr('data-start-datum', result.StartDatum).attr('data-gueltig-ab', result.GueltigesStartDatumAb);
					if (!self.istNeuesAboShopDesign) {
						$(`#${self.VonFormatiertId}${templateId}`).text(result.VonFormatiert);
						$(`#${self.BisFormatiertId}${templateId}`).text(result.BisFormatiert);
					}
					self.makeDatePicker(`${datumId}${templateId}`, `${result.StartDatum}`);
				}
				$(`#${datumId}${templateId}`).prop('disabled', !wurdenAlleChildAbosGewaehlt);

				$select.closest('div').next('.abo-detail-Liefertage').text(liefertageText);
				self.SetzeKombiAusgaben(form);
			})
			.trigger('change');
	},
	SetzeKombiAusgaben: function (form) {
		if (this.istNeuesAboShopDesign) {
			let ausgabenText = '';
			let nichtgesetzt = 0;
			$(form)
				.find('select[name^="GewaehlteAbos"]')
				.each(function () {
					const selektierteAusgabe = $(this).find('option:selected');
					if (selektierteAusgabe.val() > 0) {
						const tempText = selektierteAusgabe.text();
						if (ausgabenText.length === 0) {
							ausgabenText = tempText;
						} else {
							ausgabenText = [ausgabenText, tempText].join(', ');
						}
					} else {
						nichtgesetzt++;
					}
				});

			let nichtgesetztText = nichtgesetzt === 1 ? 'Eine Ausgabe zu wählen' : `${nichtgesetzt} Ausgaben zu wählen`;
			if (ausgabenText.length === 0) {
				ausgabenText = nichtgesetztText;
			} else if (nichtgesetzt !== 0) {
				ausgabenText = [ausgabenText, nichtgesetztText].join(', ');
			}
			$(`#kombiAbo-ausgaben-${form.data('aboTemplateId')}`).val(ausgabenText);
		}
	},
	getAboTemplateData: function () {
		const aboTemplates = [];
		const templateList = $('.AboListItemForm:visible');
		templateList.each(function () {
			const aboTemplate = $(this).data();
			if (aboTemplate) {
				aboTemplates.push({
					GewaehltesAboTemplateId: aboTemplate.aboTemplateId,
					IstDigitalAbo: aboTemplate.istDigitalAbo,
					AusgabeNr: aboTemplate.ausgabeNr,
					VonEingegeben: $(`#VonEingegeben${aboTemplate.aboTemplateId}`).val(),
					IstKombiAbo: aboTemplate.istKombiAbo,
				});
			}
		});
		return aboTemplates;
	},
	ermittleStartundLetzteVersandDatum: async function () {
		const self = this;
		const datumId = self.AngezeigtesDatumId !== undefined ? self.AngezeigtesDatumId : self.VonId;
		const aboAutraegeSubItemListe = this.getAboTemplateData();
		aboAutraegeSubItemListe.filter(x => x.IstKombiAbo === 'False').every(item => $(`#${datumId}${item.GewaehltesAboTemplateId}`).prop('disabled', true));
		const result = await fetcher.postJson(this.ermittleStartundLetztesVersandDatumUrl, { AboAutraegeSubItemListe: aboAutraegeSubItemListe });
		for (let item of result) {
			if (!item.IstKombiAbo) {
				$(`#${self.VonEingegebenId}${item.GewaehltesAboTemplateId}`).val(item.VonEingegeben);
				$(`#${datumId}${item.GewaehltesAboTemplateId}`).val(item.AngezeigtesDatum).attr('data-start-datum', item.StartDatum).attr('data-gueltig-ab', item.GueltigesStartDatumAb);
				if (!self.istNeuesAboShopDesign) {
					$(`#${self.VonFormatiertId}${item.GewaehltesAboTemplateId}`).text(item.VonFormatiert);
					$(`#${self.BisFormatiertId}${item.GewaehltesAboTemplateId}`).text(item.BisFormatiert);
				}
				self.makeDatePicker(`${datumId}${item.GewaehltesAboTemplateId}`, `${item.StartDatum}`);
				$(`#${datumId}${item.GewaehltesAboTemplateId}`).prop('disabled', false);
			}
		}
	},
	makeDatePicker: function (id, startDate) {
		const self = this;
		const datecontrol = new JJK.DateControl({
			id: id,
			sprache: self.aktuelleSprache,
			getMinDate: function () {
				return new Date(startDate);
			},
		});
		return datecontrol;
	},
};

function SetId(feld, id) {
	$(`#${feld}`, `[data-abo-template-id="${id}"]`).attr('id', feld + id);
	$(`label[for="${feld}"]`, `[data-abo-template-id="${id}"]`).attr('for', feld + id);
}

// End JJK.AboAuftraegeListe ***************************************************************************************************
